module.exports = "/img/_/_/_/assets/images/creeper/book/common//24.jpg?f3960d4934a7d25224e7f2cec4d6da75";